import { Link } from "react-router-dom";

export default function CtaBand() {
  return (
    <section className="py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-primary-500 to-primary-600 text-background-50 p-8 md:p-14">
          <div className="absolute -top-20 -right-20 w-72 h-72 rounded-full bg-accent-400/40 blur-3xl pointer-events-none" />
          <div className="absolute -bottom-24 -left-10 w-72 h-72 rounded-full bg-background-50/10 blur-3xl pointer-events-none" />
          <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
            <div className="lg:col-span-8">
              <h2 className="text-3xl md:text-5xl font-semibold leading-tight font-heading">
                Ready to route smarter?
              </h2>
              <p className="mt-4 text-background-100/90 text-base md:text-lg max-w-2xl">
                Send us your top three destinations and expected monthly volume — we&apos;ll come back with a real LCR quote you can plug straight into your dialer.
              </p>
            </div>
            <div className="lg:col-span-4 flex flex-col sm:flex-row lg:flex-col gap-3 lg:items-end">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center gap-2 bg-background-50 text-primary-700 hover:bg-background-100 px-6 py-3.5 rounded-md text-sm font-semibold whitespace-nowrap cursor-pointer transition-colors"
              >
                Request a quote
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
              </Link>
              <a
                href="#inquiry"
                className="inline-flex items-center justify-center gap-2 bg-primary-700/40 hover:bg-primary-700/60 text-background-50 border border-background-50/30 px-6 py-3.5 rounded-md text-sm font-semibold whitespace-nowrap cursor-pointer transition-colors"
              >
                <i className="ri-file-download-line w-4 h-4 flex items-center justify-center" />
                Get rate deck
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}